import _ from 'lodash';
import 'whatwg-fetch';

import { errorNotifiy } from '../core/error-helper';

export default class Api {
  constructor(host = 'http://localhost:3000') {
    this.host = host;
  }

  get = (api, param) => {
    const apiUri = this.toUri(api, param);
    return fetch(apiUri)
      .then(this.toJson)
      .catch(_.once(errorNotifiy));
  };

  post = (api, param) => {
    const apiUri = this.toUri(api);
    const init = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(param)
    };

    console.log(init);

    return fetch(apiUri, init)
      .then(this.toJson)
      .catch(_.once(errorNotifiy));
  };

  toUri = (api, val) => {
    let apiUri = `${this.host}${api}`;
    if (val) {
      apiUri += `${val}`;
    }

    return apiUri;
  };

  toJson = (response) => {
    return response.json();
  };
}


// WEBPACK FOOTER //
// ./src/api/Api.js